﻿export class RecaptchaConfigModel {
    /**
    * light or dark
    */
    theme: string;
    /**
    * compact or normal
    */
    size: string;
    /**
    * auido or image
    */
    type: string;
    /**
    * The Public API Key
    */
    sitekey: string;
    /**
    * Generated Secure Token
    */
    stoken: string;
    /**
    * language code
    * https://developers.google.com/recaptcha/docs/language
    */
    hl: string;
    tabindex: string;
    callback:any;
    'expired-callback':any;
}
